module.exports = __webpack_public_path__ + "static/media/linkimg4.846b067f.jpg";